import React from 'react'
import './VideoBackground.scss'
import { BackgroundVideoType, BackgroundVideoName as backName } from 'types'

interface Props {
  videos: BackgroundVideoType[]
  currentBack: backName
  children?: React.ReactNode
}

export const VideoBackground = (props: Props) => {
  const { videos, currentBack, children } = props
  return (
    <>
      {videos.map(v => {
        return (
          <video
            key={v.name}
            className="video"
            src={v.videoSrc}
            poster={v.imgSrc}
            crossOrigin="anonymous"
            style={v.name === currentBack ? { visibility: 'visible' } : { visibility: 'hidden' }}
            autoPlay
            loop
            playsInline
            muted
          />
        )
      })}
      {children}
    </>
  )
}
